import { useEffect, useState } from 'react';

const useIsMobile = (breakpoint: number = 768) => {
  const initial = typeof window !== 'undefined' ? window.innerWidth < breakpoint : false;
  const [isMobile, setIsMobile] = useState<boolean>(initial);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;


